import * as d3 from 'd3';
import React from 'react';
import styled from 'styled-components';

import useCommonContext from './hooks/useCommonContext';

const StyledPath = styled.path`
  fill: none;
  stroke: ${props => {
    return props.theme.enigmaBlue;
  }};
  stroke-width: 2.5px;
`;

const StyledCircle = styled.circle`
  ${props => props.theme.transition('r', '100ms')};
  fill: white;
  stroke: ${props => {
    return props.theme.enigmaBlue;
  }};
  stroke-width: 2.5px;
`;

const Component = () => {
  const { x, y, keys, data, tooltip } = useCommonContext();

  const line = d3
    .line()
    .x(d => x(d[keys.x]))
    .y(d => y(d[keys.y]));

  return (
    <g mask='url(#wipe)'>
      <StyledPath d={line(data)} />
      {data.map((d, i) => {
        return (
          <StyledCircle
            key={i}
            cx={x(d[keys.x])}
            cy={y(d[keys.y])}
            r={d === tooltip.hoverDatum ? 5 : 2.5}
          />
        );
      })}
    </g>
  );
};

export default Component;
